import React from 'react';
import './additionalInfo.less';

const AcceleratedReaderAdditionalInfo = () => (
    <div className="additional-info">
        <div className="flex-container">
            <div className="flex-item">
                <h2>Find books by Accelerated Reader level</h2>
                
                <p>Looking for information on finding books at the
                right reading level? Accelerated Reader<sup>TM</sup> levels can help. Accelerated
                Reader levels are one way to determine the appropriateness (Interest
                Level or IL) and text difficulty (Book Level or BL) of a book. Each book is
                also given a point level (AP Pts) to help teachers, students, and parents
                measure reading progress. Students and parents will be given guidance from
                their teachers what Accelerated Reader levels to look for.</p>
                
                <p>For Accelerated Reader, you will see several codes used to designate the levels:</p>
                
                <ul>
                    <li><b>IL&nbsp;</b>– Accelerated
                        Reader Interest Level assigned to the book (will be classified as LG, MG,
                        MG+, or UG)</li>
                    <li><b>BL&nbsp;</b>– Accelerated
                        Reader Book Level assigned to the book</li>
                    <li><b>AP Pts&nbsp;</b>– Accelerated Reader Points assigned to the book (this can be viewed in NoveList)</li>
                </ul>
                
                <p>Accelerated Reader Interest levels roughly correspond to grade level appropriateness:</p>
                
                <ul>
                    <li>Lower Grades (LG) (K-3)</li>
                    <li>Middle Grades (MG) (4-6)</li>
                    <li>Upper Middle Grades (MG+) (6+)</li>
                    <li>Upper Grades (UG) (9-12)</li>
                </ul>
                
                <h2>More about Accelerated
                Reader levels</h2>
                
                <p>Accelerated Reader levels are a measure of
                reading level developed by Renaissance. You can learn more about the
                Accelerated Reader level at <a target="_blank" rel="noopener noreferrer" href="https://www.renaissance.com/" >https://www.renaissance.com/</a>.</p>
            </div>
        </div>
    </div>
);

export default AcceleratedReaderAdditionalInfo;


// WEBPACK FOOTER //
// ./src/react/views/readingLevel/AcceleratedReaderAdditionalInfo.jsx